import { render, staticRenderFns } from "./ClenchFinger.vue?vue&type=template&id=01dc680d&scoped=true&"
import script from "./ClenchFinger.vue?vue&type=script&lang=js&"
export * from "./ClenchFinger.vue?vue&type=script&lang=js&"
import style0 from "./ClenchFinger.vue?vue&type=style&index=0&id=01dc680d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc680d",
  null
  
)

export default component.exports